import React, { useEffect, useState } from 'react';
import {
  TextField,
  MenuItem,
  Button,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Paper,
  Select,
  InputLabel, 
  FormControl,
   InputAdornment,
} from '@mui/material';
import axiosInstance from '../common/axios';
import InventoryTable from './InventoryTable';
import { useLanguage } from "../context/LanguageContext";

const InventoryPage = () => {
  
   const { language, changeLanguage } = useLanguage();
  const [inventoryList, setInventoryList] = useState([]);
    const [editingId, setEditingId] = useState(null);
  const [formData, setFormData] = useState({  
      inventoryId:null,
    variantId: '',
    warehouseId: '',
    inventoryStatusId: '',
    batchNumber: '',
    locationBin: '',
    expiryDate: '',
    quantity: '',
    reorderLevel: '',
    unitOfMeasureId: ''
  });

  const [warehouses, setWarehouses] = useState([]);
  const [variants, setVariants] = useState([]);
  const [statuses, setStatuses] = useState([]);
    const [unitofMeasures, setUnitofMeasures] = useState([]);
  

  useEffect(() => {
    fetchInventories();
    fetchDropdownData();
  }, []);

  const fetchInventories = async () => {
    const res = await axiosInstance.get('/api/inventories');
    setInventoryList(res.data);
  };

  const fetchDropdownData = async () => {
    const [wRes, sRes, uRes] = await Promise.all([
      axiosInstance.get('/api/warehouses/basic'),
      axiosInstance.get('/api/lookup-values/type/INVENTORY_STATUS'),
      axiosInstance.get('/api/lookup-values/type/UNIT_OF_MEASURE'),
    ]);
    setWarehouses(wRes.data);
   
    setStatuses(sRes.data);
    setUnitofMeasures(uRes.data);
  };

  
    const getProductVariantData = async(supplierId) => {
       axiosInstance.get(`/api/product-variants/all/suppliers/${supplierId}`).then(res => setVariants(res.data));
     // setVariants(vRes.data);
  };
  
  const handleChange = (e) => {
     const { name, value } = e.target;
    setFormData({ ...formData, [e.target.name]: e.target.value });
    
        
      if (name === "warehouseId") {
    setFormData((prev) => ({ ...prev, variantId: "" })); // reset product
        const selectedWarehouse = warehouses.find(wh => wh.warehouseId === value);
        console.log("selectedWarehouse.supplierId : "+ selectedWarehouse.supplierId);
    if (selectedWarehouse.supplierId) {
      getProductVariantData(selectedWarehouse.supplierId);
    } else {
      setVariants([]); // clear if no supplier selected
    }
  }
  };
  

  const handleSubmit = async () => {
    
    if (
    !formData.warehouseId ||
    !formData.variantId ||
    !formData.inventoryStatusId ||
    !formData.batchNumber ||
    !formData.locationBin ||
    !formData.expiryDate ||
    !formData.quantity ||
    !formData.reorderLevel ||
    !formData.unitOfMeasureId 
  ) {
    alert("Please fill in all required fields.");
    return;
  }
    
    if (editingId) {

      await axiosInstance.put('/api/inventories', formData);
    } else {
      await axiosInstance.post('/api/inventories', formData);
    }
    fetchInventories();
    setEditingId(null);
    setFormData({
      variantId: '',
      warehouseId: '',
      inventoryStatusId: '',
      batchNumber: '',
      locationBin: '',
      expiryDate: '',
      quantity: '',
      reorderLevel: '',
      unitOfMeasureId: '',
      inventoryId: null
    });
  };
    
      const handleEdit = (item) => {
    setFormData({
      warehouseId: item.warehouseId,
      inventoryStatusId: item.inventoryStatusId,
      variantId:item.variantId,
      batchNumber: item.batchNumber,
      locationBin: item.locationBin,
      expiryDate:item.expiryDate,
        
      quantity: item.quantity,
      reorderLevel: item.reorderLevel,
      unitOfMeasureId: item.unitOfMeasureId,
      
      inventoryId : {
                 warehouseId: item.warehouseId,
                 productVariantId: item.variantId,
                 inventoryStatusId:item.inventoryStatusId,
                 batchNumber:item.batchNumber,
                 locationBin:item.locationBin,
                 expiryDate: item.expiryDate
             }
    });
    setEditingId(item.inventoryId);
  };
    

  const handleDelete = async (item) => {
      if (window.confirm("Are you sure you want to delete this?")) {
   const inventoryId = {
                 warehouseId: item.warehouseId,
                 productVariantId: item.variantId,
                 inventoryStatusId:item.inventoryStatusId,
                 batchNumber:item.batchNumber,
                 locationBin:item.locationBin,
                 expiryDate: item.expiryDate
             };
    
    await axiosInstance.put(`/api/inventories/DELETE`,inventoryId);
    fetchInventories();
      }
  };

  return (
    <Paper sx={{ p: 4 }}>
      <h2>Add Inventory</h2>

      <FormControl fullWidth margin="normal">
        <InputLabel>Warehouse</InputLabel>
        <Select
          name="warehouseId"
          value={formData.warehouseId}
          onChange={handleChange}
          fullWidth
        disabled={!!editingId}
        helperText={editingId ? "Cannot change Warehouse when editing." : ""}
        required
        >
          {warehouses.map((w) => (
            <MenuItem key={w.warehouseId} value={w.warehouseId}>
             {w.supplierName} - {w.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <FormControl fullWidth margin="normal">
        <InputLabel>Product Variant</InputLabel>
        <Select
          name="variantId"
          value={formData.variantId}
          onChange={handleChange}
        disabled={!!editingId}
        helperText={editingId ? "Cannot change Variant when editing." : ""}
        required
        >
          {variants.map((v) => (
            <MenuItem key={v.variantId} value={v.variantId}>
              {v.variantName} - {v.size}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <FormControl fullWidth margin="normal">
        <InputLabel>Inventory Status</InputLabel>
        <Select
          name="inventoryStatusId"
          value={formData.inventoryStatusId}
          onChange={handleChange}
          required
        disabled={!!editingId}
        helperText={editingId ? "Cannot change Inventory Status when editing." : ""}
        >
          {statuses.map((s) => {
             const translatedValue = s.translations?.find(t => t.languageCode === language);
           return (
             <MenuItem key={s.id} value={s.id}>
               {translatedValue ? translatedValue.value : s.code}
            </MenuItem>
);
          })}
        </Select>
      </FormControl>

      <TextField
        label="Batch Number"
        name="batchNumber"
        value={formData.batchNumber}
        onChange={handleChange}
        fullWidth
        margin="normal"
        // The disabled prop is set to true if editingId has a value.
        disabled={!!editingId}
        helperText={editingId ? "Cannot change Batch Number when editing." : ""}
        required
      />
      <TextField
        label="Location Bin"
        name="locationBin"
        value={formData.locationBin}
        onChange={handleChange}
        fullWidth
        margin="normal"
        disabled={!!editingId}
        helperText={editingId ? "Cannot change location bin when editing." : ""}
        required
      />
      <TextField
        type="date"
        label="Expiry Date"
        name="expiryDate"
        value={formData.expiryDate}
        onChange={handleChange}
        fullWidth
        margin="normal"
        InputLabelProps={{ shrink: true }}
        disabled={!!editingId}
        helperText={editingId ? "Cannot change Expiry Date when editing." : ""}
        required
      />
      <TextField
        type="number"
        label="Quantity"
        name="quantity"
        value={formData.quantity}
        onChange={handleChange}
        fullWidth
        margin="normal"
        required
      />
      <TextField
        type="number"
        label="Reorder Level"
        name="reorderLevel"
        value={formData.reorderLevel}
        onChange={handleChange}
        fullWidth
        margin="normal"
        required
      />
          
                <FormControl fullWidth margin="normal">
        <InputLabel>Unit of Measure</InputLabel>
        <Select
          name="unitOfMeasureId"
          value={formData.unitOfMeasureId}
          onChange={handleChange}
          required
        >
          {unitofMeasures.map((s) => {
             const translatedValue = s.translations?.find(t => t.languageCode === language);
           return (
             <MenuItem key={s.id} value={s.id}>
               {translatedValue ? translatedValue.value : s.code}
            </MenuItem>
);
          })}
        </Select>
      </FormControl>

  <Button type="submit" variant="contained" onClick={handleSubmit} color="primary">
          {editingId ? 'Update' : 'Save'}
        </Button>

      <h2 style={{ marginTop: '2rem' }}>Inventory List</h2>
      <InventoryTable
  inventoryData={inventoryList}
  handleDelete={handleDelete}
  handleEdit={handleEdit}
/>

    </Paper>
  );
};

export default InventoryPage;
